import { useTranslation } from 'react-i18next';
import Back1 from '../assets/images/back-home-1.webp';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import ServiciosPage from '../pages/ServiciosPage';

export const Servicios = () => {
  const { t, i18n } = useTranslation();
  return (
    <Layout backgroundimage={Back1} actionDemo={false}>
      <SEO
        title={t("Onboarding digital integral para Fintech.")}
        description={t('Simplifica la captación de clientes con onboarding digital, rápido y seguro desde el primer contacto.')}
        bolImage={false}
        works={[
          t('Core Financiero'),
          t('Fintech'),
          t('Onboarding digital'),
          t('Aprobación de crédito'),
          t('Gestión de cobranza'),
          t('Análisis de crédito'),
          t('Core Bancario'),
          t('Automatización de procesos'),
          t('Procesos digitales'),
          t('Producto financiero'),
          t('Servicios financieros'),
          t('Digitalización de procesos'),
          t('Software financiero'),
          t('Dispersión'),
          t('Reportes automatizados'),
          t('Corebanking'),
          t('Sector financiero'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
          t('Condusef'),
          t('Servicios financieros digitales'),
          t('Plataforma financiera'),
        ]}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        canonicalUrl={`https://dynamicore.io/${i18n.language === 'en' ? 'en/onboarding' : 'onboarding'}`}
        hreflang={[
          { url: "https://dynamicore.io/onboarding", lang: "es" },
          { url: "https://dynamicore.io/en/onboarding", lang: "en-us" }
        ]}
      />
      <ServiciosPage/>
    </Layout>
  )
}
